import { Chat } from "@/store/ChatGlobalState"

export const filterUnreadedChats = (chats: Chat[]): Chat[] => {
	return chats
		.filter((chat) => chat.unreadMessagesCount >= 1 || chat.consolidatedData.markedUnread)
}
